<template>
  <div class="exhibition" id="target">
    <back-top :visibility-height="200" :right="40" :bottom="40" />
    <!--头部-->
    <nav-exhibition :currentIndex="0" :control="true" />
<!--    <div class="index-banner-top" :style="{'background':'url(' + topImgSrc + ')'}">-->
    <div class="index-banner-top">
      <div
        style="width: 1224px; margin: 20px auto 0; padding-left: 30px;padding-top: 100px;padding-bottom: 20px;padding-right: 30px;"
      >
<!--        <a :href="topImgLink"><img :src="topImgSrc" /></a>-->
        <div class="unit_tp" :style="{'background':'url(' + topImgSrc + ')'}">
          <a href="coOrganizer.html">
          <button style="background: #f27a01;border-radius: 5px;
                       color: #FFFFFF;border: none;padding: 5px 34px 5px 12px;
                       position: absolute;top: 192px;left: 239px;font-size: 16px;font-weight: 600;line-height: 28px;cursor: pointer;">查看更多
            <img src="../../assets/img/jiantou.png" style="position: absolute;top:7px;right: 12px;height: 20px;width: 14px;">
          </button>
          </a>
          <a href="supportUnit.html">
            <button style="background: #f27a01;border-radius: 5px;
                       color: #FFFFFF;border: none;padding: 5px 34px 5px 12px;
                       position: absolute;top: 294px;left: 241px;font-size: 16px;font-weight: 600;line-height: 28px;cursor: pointer;">查看更多
              <img src="../../assets/img/jiantou.png" style="position: absolute;top:7px;right: 12px;height: 20px;width: 14px;">
            </button>
          </a>

        </div>

        <div v-if="allNotice"
             style="background-color:#FFFFFF;box-shadow: 0px 0px 12px 1px rgba(0, 113, 255, 0.1);
                    padding-left: 20px; border-radius:10px;width: 1180px;margin-left: 11px;
                    position: absolute; bottom: -26px; z-index: 2">
          <marquee style="color:#999999;" :leftTitle="language.notice1" :content="allNotice" :trumpet="true"></marquee>
          <div style="width: 2px;height: 35px;background-color: #d9d9d9;position: absolute;top: 9px;left: 105px;"></div>
        </div>

      </div>

      <!-- <div
        v-else  rgba(255,255,255,0.2);
        style="width: 1224px; margin: 0px auto; padding-left: 100px; padding-top: 100px"
      >
        <img :src="cn_topImgSrc" />
      </div> -->
    </div>
    <div class="exhibition-content-wrap">
      <!--背景图片-->
      <div class="bg-wrap" v-if="bgList.length != 0">
        <div v-for="(item, index) in bgList" :key="index"></div>
      </div>
      <div class="content-wrap" ref="contentWrap">
        <!--单视频-->
        <div
          v-if="carouselType == 1"
          style="position:relative;width:1170px;height:260px; margin:0 auto;padding-top: 50px;"
        >
          <video
            :src="carouselImage[0].url"
            autoplay="autoplay"
            muted
            controls
            loop="loop"
            style="width:1170px;height:260px;object-fit:fill"
            v-if="carouselType == 1"
            webkit-playsinline="true"
            playsinline="true"
            x5-video-player-type="h5-page"
            :key="1"
          />
        </div>
      <!-- 多视频 -->
        <el-carousel
          :interval="optiontime.loop_time"
          arrow="hover"
          height="260px"
          :initial-index="0"
          style="width:1180px;margin: 0 auto; padding-top: 50px;"
          @change="handleCarousel"
          v-if="
            (carouselType == 2) &&
              carouselImage.length != 0
          "
        >
          <el-carousel-item v-for="(item, index) in carouselImage" :key="index">
            <div
              class="videoBox"
              v-if="carouselType == 2"
              style="object-fit:cover;width: 100%;min-width:1170px;height:260px; top:0;left: 0px;"
            >
              <!-- <img
                class="poster"
                v-if="b == true"
                :src="item.url"
                style="object-fit:fill;width: 100%;min-width: 1200px;height: 400px"
                @click="playv"
                @touchstart="playv"
              /> -->
              <video :src="item.url"
                autoplay="autoplay"
                muted
                class="poster"
                v-if="b == true"
                style="object-fit:fill;width: 100%;min-width: 1224px;height: 400px"/>
<!--              :muted="isIE() || _isMobile() ? '' : 'muted'"-->
              <video
                :tsrc="item.url"
                :msrc="item.url"
                loop
                :id="`video${index}`"
                style="object-fit:fill;min-width: 1224px;height: 270px"
                playsinline="true"
                v-if="carouselType == 2"
                webkit-playsinline="true"
                autoplay="autoplay"
                muted
                :key="2"
                :poster="item.url"
                x5-video-player-type="h5-page"
              ></video>

              <!-- <img
                src="imgs/bofang.png"
                v-if="b == true"
                class="playIcon"
                @click="playv"
                @touchstart="playv"
              /> -->
              <controls :index="index" v-if="isIE()" />
            </div>
            <!-- <a
              :href="item.url"
              target="_blank"
              v-if="carouselType == 4"
              style="width: 100%;height: 100%;display: block"
              :key="4"
            >
              <img
                preload
                :src="item.imgurl"
                style="width: 100%;min-width:1200px;height: 400px;border:0px;object-fit: cover"
              />
            </a> -->
          </el-carousel-item>
        </el-carousel>
        <!-- 图片轮播 -->
        <swiper
          ref="mySwiper"
          :options="swiperOptions"
          style="width:1200px;margin:0 auto;display:block;min-width:1170px;padding-top: 50px;"
          v-if="carouselImage.length > 0 && carouselType == 4"
        >
          <swiper-slide v-for="(item, index) in carouselImage" :key="index">
            <a
              :target="item.link_url?'_blank':''"
              :href="item.link_url?item.link_url:'javascript:;'"
              style="width: 100%;height: 100%;display: block"
            >
              <img
                preload
                :src="item.url + '?imageMogr2/thumbnail/1170x260'"
                style="width: 100%;min-width:1170px;object-fit: cover"
              />
            </a>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>

        <announcement
          :data-list="dataList"
          :datacount="datacount"
          v-if="dataList.length != 0 && datacount != 0"
        ></announcement>

        <!--搜索框
        <div class="search">
          <el-form
            style="background: #fff !important;"
            :inline="true"
            label-suffix=":"
            size="large"
            @keydown.enter.stop="search"
          >
            <el-form-item
              style="border-radius: 5px;overflow:hidden;width: 242px;margin-right:15px !important;"
            >
              <el-select
                v-model="exhibitionState"
                :placeholder="language.exhibitionState"
                style="width:242px;border-radius: 5px;font-size:14px;color: #fff;"
              >
                <el-option
                  v-for="item in ExhIndexType"
                  :key="item.type"
                  :label="item.name"
                  :value="item.type"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              style="width: 782px;border-radius: 5px;overflow:hidden;margin-right:15px !important;"
            >
              <el-input
                v-model="companyName"
                style="width: 782px;border-radius: 5px;"
                @keyup.enter.native="search"
                :placeholder="language.indexSou"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                size="small"
                type="primary"
                style="width: 126px;height: 40px;border-radius: 5px;margin-top: 0.7px；font-size: 16px;"
                @click.native="search"
              >
                <span v-if="lan == 'ch'" style="font-size:16px;">搜索</span>
                <span v-else style="font-size:16px;">search</span>
              </el-button>
            </el-form-item>
          </el-form>
        </div>-->

<!--        &lt;!&ndash;首页上方视频&ndash;&gt;-->
<!--        <div style="width: 1200px;margin: 10px auto;position: relative;" v-if="video_pathTop">-->
<!--          <video-->
<!--              :src="video_pathTop"-->
<!--              controls-->
<!--              autoplay-->
<!--              loop="loop"-->
<!--              webkit-playsinline="true"-->
<!--              playsinline="true"-->
<!--              width="100%"-->
<!--              type="video/mp4"-->
<!--              :poster="video_pathTop"-->
<!--              muted-->
<!--              x5-video-player-type="h5-page"-->
<!--              ref="videoRef4"-->
<!--          ></video>-->
<!--&lt;!&ndash;          :muted="_isMobile() ? '' : 'muted'"&ndash;&gt;-->
<!--        </div>-->

        <!-- 分割图片 -->
        <div class="division-div" style="margin-top: 40px;">
<!--          <img v-if="lan=='ch'" src="../../assets/img_exhibition_ch.png" alt />-->
<!--          <img v-if="lan=='en'" src="../../assets/img_exhibition_en.png" alt />-->
          <!--推荐企业-->
<!--          <div style="text-align: center;height: 80px;">-->
<!--&lt;!&ndash;            <div style="width: 70px;height: 5px;background: #f47900;&ndash;&gt;-->
<!--&lt;!&ndash;                                margin:30px auto 4px;"></div>&ndash;&gt;-->
<!--&lt;!&ndash;            <div style="color: #0071ff;font-size: 30px;font-weight: bold;z-index: 2;">招聘会列表</div>&ndash;&gt;-->
<!--&lt;!&ndash;            <div style="color: #0071ff;font-size: 40px;font-weight: bold;opacity: 0.2;position: relative;top: -30px;">&ndash;&gt;-->
<!--&lt;!&ndash;              EXHIBIHON AREA</div>&ndash;&gt;-->
<!--            <img src="../../assets/img/shou3.png" style="margin: 10px auto;width: 152px;">-->
<!--          </div>-->

        </div>
        <!--内容-->
        <div class="search_content" v-if="!searching">
          <search-content
            class="content"
            v-for="(item, index) in exhibitionList"
            :key="index"
            :language="language"
            :exhObject="item"
            :exhIndex="item.id"
            :lang="lan"
            @join-activities="handledTypeJoin"
            @join-handleRegister="handleRegister"
          ></search-content>
          <div
            v-if="showContentMore == true"
            class="search_content_more"
            @click="seeSearchContentMore"
          >
            <p v-if="lan == 'ch'">点击查看更多 ></p>
            <p v-else>more</p>
          </div>
          <div class="home-secondtongAd" v:if="indexfilepath!='' " style="height:80px;"></div>

        </div>


        <div class="search_content" v-if="searching">
          <!-- :exhState="intro.exh_type" -->
          <new-one-to-one
            :language="language"
            style="margin-top: 20px;"
            :aloneData="liveList"
            :lan="lan"
            indexType="index"
            @showParticipants="showParticipants"
          />
          <pagination
            v-show="total > 0"
            class="pagination"
            :total="total"
            :limit.sync="numberPage"
            :page.sync="page"
            @pagination="handleExhList"
          />
        </div>
      </div>
      <div class="">
        <div class="banner2"></div>
        <div class="division-div" style="margin-top: 30px;">
          <!--热门岗位-->
          <div style="text-align: center;height: 80px;">
<!--            <div style="width: 70px;height: 5px;background: #0071ff;-->
<!--                                  margin:30px auto 4px;"></div>-->
<!--            <div style="color: #0071ff;font-size: 30px;font-weight: bold;z-index: 2">热门岗位</div>-->
<!--            <div style="color: #0071ff;font-size: 40px;font-weight: bold;opacity: 0.2;position: relative;top: -30px;">-->
<!--              EXHIBIHON AREA</div>-->
            <img src="../../assets/img/shou2.png" style="width: 121px; margin: 10px auto;">
          </div>

        </div>
        <div class="banner3">
          <img style="margin-bottom: 60px;margin-top: 30px;" src="../../assets/img/20.png">
        </div>
        <div class="banner4"></div>
      </div>

<!--      <div class="index_bottom">-->
<!--        <div class="division-div" style="margin-top: 50px;">-->
<!--          &lt;!&ndash;他们都在用WIFFA直聘&ndash;&gt;-->
<!--          <div style="text-align: center;height: 80px;">-->
<!--            <img src="../../assets/img/shou1.png" >-->
<!--          </div>-->
<!--        </div>-->
<!--        <div style="width: 1200px;margin: 0 auto;">-->
<!--          <div class="bottom-left" style="float: left;">-->
<!--            <div class="firmMes" >-->
<!--              <div style="width: 132px;height:100%;float: left;">-->
<!--                <img src="../../assets/img/51.png" style="width: 115px;height:96px;margin-left: 25px;margin-top: 12px;">-->
<!--              </div>-->
<!--              <div class="mesright">-->
<!--                <div class="mesTitle">大连市仓储与配送协会</div>-->
<!--                <div class="mesContent">大连市仓储与配送协会于2006年6月成立，具有3A社团法人资格。目前拥有会员单位118家，业务涵盖仓储、城市配送、物流园区、第三方物流、仓储设施、信息化等领域。</div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="firmMes">-->
<!--              <div style="width: 132px;height:100%;float: left;">-->
<!--                <img src="../../assets/img/52.png" style="width: 137px;height:74px;margin-left: 10px;margin-top: 38px;">-->
<!--              </div>-->
<!--              <div class="mesright">-->
<!--                <div class="mesTitle">漯河市物流与采购联合会</div>-->
<!--                <div class="mesContent">漯河市物流与采购联合会，是漯河市民政局正式注册综合性社团法人组织；是河南省物流与采购联合会在漯河市唯一认可的专业物流行业组织。目前有100多家企事业会员单位。</div>-->
<!--              </div>-->
<!--            </div>-->
<!--&lt;!&ndash;            <div class="firmMes">&ndash;&gt;-->
<!--&lt;!&ndash;              <img src="../../assets/img/DGS.png" style="width: 132PX;height: 38px;float: left;margin-left: 20px;margin-top: 49px;">&ndash;&gt;-->
<!--&lt;!&ndash;              <div class="mesright">&ndash;&gt;-->
<!--&lt;!&ndash;                <div class="mesTitle">江苏通泽集团（越南分公司）</div>&ndash;&gt;-->
<!--&lt;!&ndash;                <div class="mesContent"> 企业介绍 企业介绍 企业介绍 企业介绍 企业介绍 企业介绍 企业介绍 企业介绍</div>&ndash;&gt;-->
<!--&lt;!&ndash;              </div>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--          </div>-->
<!--          <div class="bottom-right" style="float: right;">-->
<!--            <div class="firmMes" >-->
<!--              <div style="width: 132px;height:100%;float: left;">-->
<!--                <img src="../../assets/img/53.png" style="width: 105px;height:105px;margin-left: 20px;margin-top: 25px;">-->
<!--              </div>-->
<!--              <div class="mesright">-->
<!--                <div class="mesTitle">大连市供应链管理服务行业协会</div>-->
<!--                <div class="mesContent">大连市供应链管理服务行业协会，2018年6月由大连市民政局批准注册的社会团体法人。会员由大连地区生产制造、商贸流通、社会与生产服务、IT及社会各界供应链管理等企业自愿组成。</div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="firmMes">-->
<!--              <div style="width: 132px;height:100%;float: left;">-->
<!--                <img src="../../assets/img/50.png" style="width: 106px;height: 106px;margin-left: 20px;margin-top: 37px;">-->
<!--              </div>-->
<!--              <div class="mesright">-->
<!--                <div class="mesTitle">沈阳物流协会</div>-->
<!--                <div class="mesContent">沈阳物流行业协会是中铁物资集团东北有限公司等13家物流企业共同发起成立，由全市各种经济成份的物流企业及相关的科研、教学单位自愿结成。 2016年6月经沈阳市民政局核准注册登记的社团法人。2021年被沈阳市民政局评定为5A级社会组织。</div>-->
<!--              </div>-->
<!--            </div>-->
<!--&lt;!&ndash;            <div class="firmMes">&ndash;&gt;-->
<!--&lt;!&ndash;              <img src="../../assets/img/DGS.png" style="width: 132PX;height: 38px;float: left;margin-left: 20px;margin-top: 49px;">&ndash;&gt;-->
<!--&lt;!&ndash;              <div class="mesright">&ndash;&gt;-->
<!--&lt;!&ndash;                <div class="mesTitle">江苏通泽集团（越南分公司）</div>&ndash;&gt;-->
<!--&lt;!&ndash;                <div class="mesContent"> 企业介绍 企业介绍 企业介绍 企业介绍 企业介绍 企业介绍 企业介绍 企业介绍</div>&ndash;&gt;-->
<!--&lt;!&ndash;              </div>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->

<!--          </div>-->
<!--        </div>-->

<!--&lt;!&ndash;        <div>&ndash;&gt;-->
<!--&lt;!&ndash;          <img src="../../assets/1.png" alt />&ndash;&gt;-->
<!--&lt;!&ndash;          <p v-if="lan=='ch'">定制口岸会员之间合作细则</p>&ndash;&gt;-->
<!--&lt;!&ndash;          <p>Cooperation details</p>&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--&lt;!&ndash;        <div>&ndash;&gt;-->
<!--&lt;!&ndash;          <img src="../../assets/2.png" alt />&ndash;&gt;-->
<!--&lt;!&ndash;          <p v-if="lan=='ch'">定制口岸会员之间信用合作机制</p>&ndash;&gt;-->
<!--&lt;!&ndash;          <p>Credit cooperation</p>&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--&lt;!&ndash;        <div>&ndash;&gt;-->
<!--&lt;!&ndash;          <img src="../../assets/3.png" alt />&ndash;&gt;-->
<!--&lt;!&ndash;          <p v-if="lan=='ch'">口岸合作委员会重要事项决策表决</p>&ndash;&gt;-->
<!--&lt;!&ndash;          <p>Decision making voting</p>&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--&lt;!&ndash;        <div>&ndash;&gt;-->
<!--&lt;!&ndash;          <img src="../../assets/4.png" alt />&ndash;&gt;-->
<!--&lt;!&ndash;          <p v-if="lan=='ch'">WIFFA内部裁定小组成员</p>&ndash;&gt;-->
<!--&lt;!&ndash;          <p>Team members</p>&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--&lt;!&ndash;        <div>&ndash;&gt;-->
<!--&lt;!&ndash;          <img src="../../assets/5.png" alt />&ndash;&gt;-->
<!--&lt;!&ndash;          <p v-if="lan=='ch'">WIFFA海外联合委员会</p>&ndash;&gt;-->
<!--&lt;!&ndash;          <p>Overseas Committee</p>&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--      </div>-->





      <div :class="lan == 'ch' ? 'index-diqiu' : 'index-diqiu-en'">
<!--        <div style="position: relative;left: 700px;top: 350px; height: 300px;">-->
<!--          <p class="word">虚位以待 只等你来</p>-->
<!--          <div style="width: 415px;height: 14px;background-color: #0071ff;position: relative;left: 45px;top:-9px;z-index: -1"></div>-->
<!--          <p class="word1">机会是留给有准备的人</p>-->
<!--        </div>-->
<!--        autoplay="autoplay"-->
<!--        padding-top: 8vw;-->
        <div style="width: 1200px;margin:auto;">
          <div style="width: 835px;margin: auto;position: relative;top: 160px;
                      border-top: 10px rgba(0,0,0,0.1) solid;border-bottom: 10px rgba(0,0,0,0.1) solid;
                      border-left: 20px rgba(0,0,0,0.1) solid;border-right: 20px rgba(0,0,0,0.1) solid">
            <video
                :src="video_path"
                controls
                loop="loop"
                webkit-playsinline="true"
                playsinline="true"
                width="100%"
                type="video/mp4"
                :poster="video_img"
                :muted="_isMobile() ? '' : 'muted'"
                x5-video-player-type="h5-page"
                ref="videoRef4"
            ></video>
          </div>
        </div>

      </div>
    </div>
    <hint-message
      :show.sync="showHint"
      :title="title"
      @confirm="getConfirm"
      :promptContent="promptContent"
      :loginData="loginData"
      :type="type"
    />
    <!--底部-->
    <footer-blogroll
      :language="language"
      paramsIndex="internationalFair"
      style="margin-top:-5px;"
    />
    <count-down-dialog :wait-data="warnConten" :show.sync="warnVisible" />

  <!--左侧浮漂快速入口-->
  <div class="entrance-left-wrap" v-if="showleftFastEntry == true">
    <div class="entrance-left-ad">
      <a :href="homeADListUrl" target="_blank"  v-if="lan == 'ch'"><img :src="homeADList" alt=""></a>
<!--      <a href="https://www.wiffa-exh.com/forum.html?exhibition_id=49&room_id=4251" target="_blank"  v-else><img :src="homeADList" alt=""></a>-->

      <span class="new-code-btn-right" style="right: 25px;" @click="showleftFastEntry = false" v-if="rightCloseADbtn">
        <img src="../../assets/img/close.png" alt />
      </span>
    </div>
  </div>


    <!-- 右侧浮漂快速入口 -->
    <div class="entrance-right-wrap" v-if="showRightFastEntry == true">
      <div class="entrance-right-top">
        <span v-if="lan == 'ch'">招聘会快速入口</span>
        <span v-else>Fast entry to the exhibition</span>
      </div>
      <div class="entrance-right-content">
        <template v-for="(item, index) in exhibitionList">
          <div
            :key="index"
            @click="
              handledTypeJoin(
                ExhibitionHandleEnum.ENTER_ROOM,
                item.exhibition_id
              )
            "
            v-if="index < 5"
            style="color: #666666"
          >
            <span v-if="lan == 'ch'">{{ item.exh_name.substr(0, 16) }}...</span>
            <span v-else>{{ item.exh_name_en.substr(0, 30) }}...</span>
          </div>
        </template>
      </div>
      <!--    <el-backtop class="entrance-right-bottom" :visibility-height="50"-->
      <!--    >-->
      <!--      <span v-if="lan == 'ch'">返回顶部</span>-->
      <!--      <span v-else>Back top</span>-->
      <!--    </el-backtop>-->
      <!--    <div class="entrance-right-bottom">-->
      <!--      <span v-if="lan == 'ch'">返回顶部</span>-->
      <!--      <span v-else>Menu top</span>-->
      <!--    </div>-->

     <!--广告宣传链接-->

      <a href="adintroduce.html" >
          <div class="adSideLink">
            <img v-if="lan=='ch'" :src="adSideLinkImg" alt="" />
            <img v-else :src="adSideLinkImgen" alt="" />
         </div>
     </a>



      <div class="entrance-right-qrcode" style="margin-top: 10px"  v-if="lan == 'ch'">
        <img
          src="../../assets/img/28.jpg"
          style="width: 120px;height: 120px;padding: 20px 20px 0;"
        />
        <p v-if="lan == 'ch'">扫一扫进入小程序</p>
        <p v-else>Scan to enter the applet</p>
      </div>
      <span class="new-code-btn-right" style="right: 60px;" @click="showRightFastEntry = false">
        <img src="../../assets/img/close.png" alt />
      </span>
    </div>

    <!--漂浮广告--start-->
    <div>
      <!--右侧二维码边栏--start-->
      <div class="advisory advisory-left" id="advisory" style="display:none;">
        <a :href="duilianUrl" target="_blank">
          <div class="advisory-img">
            <img :src="duilianImg" alt />
          </div>
        </a>
        <span class="code-btn code-btn-left">
          <img src="../../assets/img/close.png" alt />
        </span>
      </div>

      <!--右侧二维码边栏--start-->
      <div class="advisory advisory-right" id style="display:none;">
        <a :href="duilianUrl" target="_blank">
          <div class="advisory-img">
            <img :src="duilianImg" alt />
          </div>
        </a>
        <span class="code-btn code-btn-right">
          <img src="../../assets/closebtn.png" alt />
        </span>
      </div>
    </div>
    <!--漂浮广告--end-->

    <!--右侧第一站广告--start
    <div class="advisory advisory-left show—advisory" id="advisory">
      <a :href="duilianUrl" target="_blank">
        <div class="advisory-img">
          <img :src="exhibitionImg" alt />
        </div>
      </a>
      <span class="code-btn code-btn-left">
        <img src="../../assets/closebtn.png" alt />
      </span>
    </div>-->

    <!-- 邀请码分享 -->
    <el-dialog
      title
      :visible.sync="showImgDialogFormVisible"
      width="1200px"
      top="10vh"
      class="dislogCon-Img"
      style="margin: 0 auto;text-align:center;"
    >
      <!-- <img :src="imgSrc" alt="" style="margin: 0 auto;text-align:center;"> -->
      <div class="img-wrap">
        <div class="img-wrap-left">
          <img class="choose-img" :src="imgSrcList[imgSrcIndex]" alt />
        </div>
        <div class="img-wrap-right">
          <div class="img-wrap-title">
            <p>制作手机海报分享</p>
            <div class="div-border-bottom-color"></div>
          </div>
          <div class="img-wrap-right-top">
            <div
              :class="
                imgSrcIndex == index
                  ? 'img-wrap-right-top-div img-wrap-right-top-div-active'
                  : 'img-wrap-right-top-div'
              "
              v-for="(item, index) in imgSrcList"
              :key="index"
            >
              <img :src="item" alt @click="changeImgSrc(index)" />
              <img
                v-if="imgSrcIndex == index"
                class="img-right"
                src="../../assets/icon-right.png"
                alt
              />
            </div>
          </div>
          <div class="img-formBtn">
            <el-button class="img-down-formBtn" @click.native="imgDown"
              >下载</el-button
            >
            <el-button
              class="img-camcale-formBtn"
              type="primary"
              @click.native="cancelImg"
              >取消</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title
      :visible.sync="showParticipantsDialogFormVisible"
      width="1200px"
      top="25vh"
      class="dislogCon-Participants"
      style="margin: 0 auto;text-align:center;"
    >
      <!-- :aloneData="participants" -->
      <div
        class="dialog-top"
        style="background:#f2f2f2 !important;border-radius:5px;clear:both;overflow:hidden; margin-bottom: 20px;"
      >
        <div style="text-align: center">
          <div
            style="margin: 40px auto 0px -40px;
                   border-radius: 50%; height: 70px; width: 70px; overflow: hidden;
                    background: rgb(255, 255, 255); position: absolute; top: 10px; left: 50%;padding:20px;"
          >
            <img
              :src="
                broadCastList.company_logo_url == ''
                  ? moren
                  : broadCastList.company_logo_url
              "
              alt
              style="width: 100%;height: 100%;border-radius: 50%;"
            />
          </div>
          <div style="position: absolute;right: 51px;top:60px;">
            <template v-if="lan == 'ch'">
              <div style="display: inline-block;margin-right:20px;">
                <el-button
                  type="primary"
                  @click="
                    showImg({
                      currentTab: 1,
                      exhibition_id: broadCastList.finally_in_exhibtion,
                      broadcast_id: broadCastList.user_id,
                    })
                  "
                  v-if="lan == 'ch'"
                  >手机海报分享</el-button
                >
                <el-button
                  type="primary"
                  @click="
                    showImg({
                      currentTab: 1,
                      exhibition_id: broadCastList.finally_in_exhibtion,
                      broadcast_id: broadCastList.user_id,
                    })
                  "
                  v-if="lan == 'en'"
                  >Share Link</el-button
                >
              </div>
            </template>

            <el-button
              type="primary"
              @click="
                showPcUrl({
                  exhibition_id: broadCastList.finally_in_exhibtion,
                  broadcast_id: broadCastList.user_id,
                })
              "
              v-if="lan == 'ch'"
              >主页链接分享</el-button
            >
            <el-button
              type="primary"
              @click="
                showPcUrl({
                  exhibition_id: broadCastList.finally_in_exhibtion,
                  broadcast_id: broadCastList.user_id,
                })
              "
              v-if="lan == 'en'"
              >showPcUrl</el-button
            >
          </div>
        </div>
        <div v-if="lan == 'ch'">
          <div class="broadCastList-company" style=" font-size: 20px;">
            {{ broadCastList.company }}
          </div>
          <!-- <div style="padding-top:20px;">{{broadCastList.location}}</div> -->
          <!-- <span style="margin-left: 30px;">{{broadCastList.user_post}}:{{broadCastList.true_name}}</span> -->
          <div style="line-height: 22px; text-align: left;padding-top: 20px;">
            {{ broadCastList.company_desc }}
          </div>
        </div>
        <div v-if="lan == 'en'">
          <div class="broadCastList-company" style="font-size: 24px;">
            {{ broadCastList.company_en }}
          </div>
          <!-- <div style="padding-top:20px;">{{broadCastList.location_en}}</div> -->
          <!-- <span style="margin-left: 30px; ">{{broadCastList.user_post_en}}:{{broadCastList.true_name_en}}</span> -->
          <div
            style="line-height: 22px; text-align: justify;padding-top: 20px;"
          >
            {{ broadCastList.company_desc_en }}
          </div>
        </div>
      </div>
      <!--          直播间三个文字-->
      <img
        src="@/assets/zhibojianwenzi.png"
        alt
        style="height: 30px; margin-top: 20px; margin-bottom: 30px;"
        v-if="lan == 'ch'"
      />
      <img
        src="@/assets/zhibojianwenzi_en.png"
        alt
        style="height: 30px; margin-top: 20px; margin-bottom: 30px;"
        v-else
      />
      <template v-for="(item, index) in broadCastList.broadCast">
        <one-to-one
          ref="ontoone"
          :key="index"
          :k="index"
          v-loading="loading"
          :language="language"
          style="margin-bottom: 40px;"
          :exhState="item.exhibitionState"
          @newToggelSubject="newToggelSubject"
          :aloneData="item"
          :lan="lan"
          @getLiveInfo="handleLive"
          @newHandleInfo="newHandleInfo"
          @showImg="showImg"
          @showPcUrl="showPcUrl"
        />
      </template>
      <pagination
        v-if="broadCastTotal > 3"
        class="pagination"
        :total="broadCastTotal"
        :limit.sync="broadCastTotalNumberPage"
        :page.sync="broadCastTotalPage"
        @pagination="broadCastTotalHandleExhList"
      />
    </el-dialog>

    <!-- 邀请码分享 -->
    <el-dialog
      title
      :visible.sync="showImgDialogFormVisible"
      width="1200px"
      top="10vh"
      class="dislogCon-Img"
      style="margin: 0 auto;text-align:center;"
    >
      <!-- <img :src="imgSrc" alt="" style="margin: 0 auto;text-align:center;"> -->
      <div class="img-wrap">
        <div class="img-wrap-left">
          <img class="choose-img" :src="imgSrcList[imgSrcIndex]" alt />
        </div>
        <div class="img-wrap-right">
          <div class="img-wrap-title">
            <p>制作手机海报分享</p>
            <div class="div-border-bottom-color"></div>
          </div>
          <div class="img-wrap-right-top">
            <div
              :class="
                imgSrcIndex == index
                  ? 'img-wrap-right-top-div img-wrap-right-top-div-active'
                  : 'img-wrap-right-top-div'
              "
              v-for="(item, index) in imgSrcList"
              :key="index"
            >
              <img :src="item" alt @click="changeImgSrc(index)" />
              <img
                v-if="imgSrcIndex == index"
                class="img-right"
                src="../../assets/icon-right.png"
                alt
              />
            </div>
          </div>
          <div class="img-formBtn">
            <el-button class="img-down-formBtn" @click.native="imgDown"
              >下载</el-button
            >
            <el-button
              class="img-camcale-formBtn"
              type="primary"
              @click.native="cancelImg"
              >取消</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- pc链接分享 -->
    <el-dialog
      :title="language.Sharelinks"
      :visible.sync="showPcUrlDialogFormVisible"
      width="1200px"
      top="30vh"
      class="dislogCon"
      style="margin: 0 auto;text-align:center;"
    >
      <div class="pc-url-div">
        <p id="copy_pc_url">{{ pcUrl }}</p>
      </div>
      <div class="url-formBtn">
        <el-button
          type="warning"
          class="pc-url-formBtn"
          @click.native="copyPcUrl"
          v-if="lan == 'ch'"
          >复制</el-button
        >
        <el-button
          type="warning"
          class="pc-url-formBtn"
          @click.native="copyPcUrl"
          v-else
          >Copy</el-button
        >
      </div>
    </el-dialog>

    <!--已购买过确认在购买弹窗-->
    <el-dialog
        :visible.sync="payExh"
        width="400px"
        top="40vh"
        style="text-align: center;color: #313030;">
      <div style="font-size: 16px;letter-spacing: 2px;line-height: 30px;width: 300px; margin: 0 auto 10px;">{{retipMess}}</div>
      <div style="margin-top: 20px;">
        <el-button style="background: #0071FF;color: #FFFFFF;padding: 10px 40px !important;margin-top: 20px;"
                   @click="payOk">确定</el-button>
        <el-button style="background: #e4e4e4;color: #333333;padding: 10px 40px !important;margin-top: 20px;margin-left: 20px;"
                   @click="payNo">取消</el-button>
      </div>
    </el-dialog>

    <!-- <line-dialog :show.sync="visibleLine" :lan="language" :waitData="waitData" :lanState="lan" /> -->
    <receiveMsg />
    <download-dialog :show.sync="downloadShow" />
  </div>
</template>

<script>
import reqest from "@/common/reqest";
import { language } from "../../language/get";
import {
  IndeList,
  noticeList,
  pcShareLink,
  selectList,
  getBroadcastList,
  getCompanysList,
  getCompanysDetails,
  getResocuseUse,
  getNoticeAll
} from "../../api/exhibition";
import navExhibition from "../../components/NavExhibition/index";
import searchContent from "./searchContent";
// import onetoone from "./oneToOne";
import {
  ExhibitionType,
  ExhibitionHandleEnum,
  ExhIndexType
} from "../../common/constant/exhibition";
import footerBlogroll from "../../components/FooterBlogroll/footerBlogroll";
import backTop from "../../components/BackTop/index";
import { mapGetters } from "vuex";
import hintMessage from "../../components/HintMessage/index";
import Cookie from "../../common/cookie";
import pagination from "../../components/Pagination/pagination";
import { init } from "../../common/socket";
import countDownDialog from "../../components/CountdownDialog";
import {
  roomUrl,
  ticketsRegisterUrl,
  tickUrl,
  windowsGoTo,
} from "../../common/url";
import { ExhType } from "../../common/constant/exhibition";
import announcement from "../../components/announcement";
import controls from "../../components/controls";
import { isEmpty, isInternet } from "@/common/validate";
import {
  liverRoomBuy,
  selectContact,
  getExhibitionRrk,
  CompanySelectList,
  getExhticketUserCount,
  getBannerList
} from "@/api/forum";
import {
  getIndexTopImg,
  getBanner,
  getExhibitionInfo,
} from "../../api/newRequest";
import { subscribe, subscribeCancel } from "@/api/btManage";
import { getCompanys } from "@/api/newRequest";
import { stateEnum } from "./oneToOne/enum";
import newOneToOne from "../forum/newOneToOne/index";
import newOneToOneDown from "../forum/newOneToOneDown/index";
import oneToOne from "../forum/oneToOne/index";
import lineDialog from "../../components/LineDialog";
import downloadDialog from "../../components/DownloadDialog/index";
import axios from "axios";
import util from "../../common/util";
import receiveMsg from "../../components/receiveMsg";
import marquee from "../../components/marquee/marquee.vue"
import { MessageBox} from 'element-ui';
import getParamter from "../../common/util";
import {getExhibitorsLogoList} from "@/api/forum";

export default {
  components: {
    navExhibition,
    searchContent,
    footerBlogroll,
    backTop,
    hintMessage,
    pagination,
    countDownDialog,
    announcement,
    controls,
    // onetoone,
    oneToOne,
    newOneToOne,
    lineDialog,
    downloadDialog,
    receiveMsg,
    marquee,
  },

  data() {
    let pageLan = getParamter.getQueryString("lan");
    if (pageLan == "ch") {
      Cookie.del("lang");
      Cookie.set("lang", "ch", 7);
    } else if (pageLan == "en"){
      Cookie.del("lang");
      Cookie.set("lang", "en", 7);
    }
    return {
      video_pathTop:"",
      video_path:"",
      video_img:"",
      payExh:false,
      retipMess:null, //再次购买弹窗提示语
      encodeData:null,
      areaName:"北京市 北京市",
      allNotice:"",
      newSubjectList: [],
      newshowSubject: false,
      subindex: 0,
      imgSrc: "",
      stateEnum,
      searching: false,
      liveList: [],
      page: 1,
      numberPage: 10,
      intro: {}, //简介
      loading: true,
      // duilianUrl: 'https://www.wiffa-exh.com/videolist.html#/',
      moren:
        "https://yunzhan-1251180497.cos.ap-nanjing.myqcloud.com/ac4e3b819acaec2d4cffdc7ab66daff7447c8421.jpeg",
      alertadUrl:
        "https://www.wiffa-exh.com/forum.html?exhibition_id=19#/",
      duilianUrl: "http://www.wiffa.net/meeting2021/pre/index.html",
      // alertadUrl: '../../videolist.html#/',
      exhibitionImg: require("../../assets/duilian_new.jpg"),
      exhibitionImg_old: require("../../assets/duilian.png"),
      duilianImg: require("../../assets/duilian.png"),
      alertadImg: require("../../assets/alertad.jpg"),
      adSideLinkImg: require('../../assets/navright-ad.png'),
      adSideLinkImgen: require('../../assets/navright-aden.png'),
      name: "",
      play: false,
      b: false,
      language: language(),
      exhibitionState: null, //展会状态
      exhibitionName: null, //展会名称
      companyName: null, //公司名称
      currentPage: 1,
      pageSize: 10,
      total: 0,
      ExhibitionType,
      carouselImage: [],
      exhibitionList: [],
      dataList: [],
      datacount: 0,
      showHint: false, //弹窗
      ExhibitionHandleEnum,
      title: "",
      promptContent: "",
      ExhType,
      type: null, //弹窗类型
      lan: Cookie.get("lang"),
      //socket弹窗
      warnConten: {},
      ExhIndexType,
      warnVisible: false,
      //轮播图
      swiperOptions: {
        direction: "horizontal",
        //轮播图自动轮播开关
        loop: false,
        // freeMode: true,
        // observer: true,
        // observeParents: true,
        autoplay: 4000,
        speed: 1000,
        slidesPerView: "auto",
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
        },
      },
      carouselType: null,
      loginData: {},
      optiontime: { loop_time: 0 },

      imgSrcList: [],
      imgSrcIndex: 0,
      showImgDialogFormVisible: false,

      participants: {},
      showParticipantsDialogFormVisible: false,
      typeIndex: 0,

      showPcUrlDialogFormVisible: false,
      pcUrl: "",

      participantsBool: false,

      abcString: "",
      broadCastList: {},

      renqi_type: "",
      broadCastTotal: 0,
      broadCastTotalNumberPage: 3,
      broadCastTotalPage: 1,

      dialogUserId: "",
      dialogFinallyInExhibtion: "",

      //排队
      visibleLine: false,
      waitData: {},
      downloadShow: false,

      bgList: [],
      showContentMore: false,
      // moreExhibitionList: [],

      showRightFastEntry: true,
      topImgSrc: "",
      topImgLink: "",
      showleftFastEntry:true,
      indexfilepath:'',
      homeADList:'',
      homeADListUrl:'',
      rightCloseADbtn:false
    };
  },
  methods: {
    //获取首页顶部图片
    getTopImg() {
      let param = {
        lan: this.lan,
        use_id: this.lan == 'ch' ? '-9898' : '-9897'
      };
      //获取顶部背景图片
      getResocuseUse(param).then((res) => {
        // console.log("===img===img===", res);
        if (res.type == 1 && res.data.length > 0) {
            this.topImgSrc = res.data[0].ch_file_path;
            this.topImgLink = res.data[0].link_url;
        }
      });
    },

    goDetailExhibition() {
      return (window.location.href = "forum.html" + "?exhibition_id=32");
    },
    toggelSubject(e) {
      this.newshowSubject = e;
    },
    closeSubject(a) {
      this.newshowSubject = a[0];
      console.log(a);

      this.broadCastList.broadCast[this.subindex].subscribe_type = 1;
    },
    // imgDown(){
    //   var alink = document.createElement("a");
    //   alink.href = this.imgSrc;
    //   alink.download = "pic.png"; //图片名
    //   alink.click();
    //   // this.$refs.dialogChild.receiveDialogFormVisible = false;
    //   this.showImgDialogFormVisible = false;
    // },

    fmt(fmt) {
      return fmt.length == 1 ? "0" + fmt : fmt;
    },
    newToggelSubject(e) {
      console.log(e, 2222222222222222222222222);
      var time = e.subscribe_set;
      var subject = [];
      for (let a in time) {
        let start = parseInt(
          new Date(time[a].days + " " + time[a].start_time).getTime() / 1000
        );
        let end = parseInt(
          new Date(time[a].days + " " + time[a].end_time).getTime() / 1000
        );
        let ls = ((end - start) / 3600) * 2;
        if (ls == 1) {
          ls = 0;
        }
        subject[a] = {
          days: time[a].days,
          broadcast_id: time[a].broadcast_id,
          time: [],
        };
        for (let i = 0; i < ls; i++) {
          let c = start + 1800 * (i + 1);
          let s = new Date((start + i * 1800) * 1000);
          let a1 = new Date(c * 1000);
          let t =
            this.fmt(s.getHours().toString()) +
            ":" +
            this.fmt(s.getMinutes().toString()) +
            "-" +
            this.fmt(a1.getHours().toString()) +
            ":" +
            this.fmt(a1.getMinutes().toString());
          let k = { time: t };
          subject[a].time.push(k);
        }
      }
      this.subindex = e.key;
      this.newSubjectList = subject;
      this.newshowSubject = e.showSubject;

      // this.newshowSubject = false;
    },
    //获取展会信息
    loadData() {
      this.exhibitionList = [];
      this.getWebStock();
      const param = {
        type: this.exhibitionState,
        keyword: this.exhibitionName,
        ckeyword: this.companyName,
        currentPage: this.currentPage,
        numberPage: 5,
        lan: this.lan,
      };
      selectList(param).then((res) => {

        let data = res.data;

        getExhibitorsLogoList({exhibition_id:'', platform_type:(this.lan == "ch"?0:1),ad_id:4,ad_type:0}).then(
          (restemp) => {
              if(restemp.data!=''&&restemp.data!=null){
                this.indexfilepath=res.data[0].file_path;
                data[0]['file_path']=restemp.data[0].file_path;
                this.exhibitionList = data;
              }else{
                this.exhibitionList = data;
              }

              // for(var index in data){
              //   for(var item in data[index]){
              //     console.log(item + "：" + data[index][item]);
              //   }
              //   console.log("====================================================")
              // }

              if (res.datacount > this.exhibitionList.length) {
                  this.showContentMore = true;
                }else{
                  this.showContentMore = false;
                }

                this.total = parseInt(res.datacount);

                this.getContentWrapHeight();

                target.scrollIntoView();
          }
      ),

        //获取左侧浮漂广告图片
       getExhibitorsLogoList({exhibition_id:'', platform_type:(this.lan == "ch"?0:1), ad_id:11, ad_type:0}).then(
        (res) => {
          if(res.data[0].file_path!=''){
            this.homeADList = res.data[0].file_path;
            this.homeADListUrl = res.data[0].tourl;
            this.rightCloseADbtn=true;
          }
        }
      );

        //获取首页下面的视频数据
        getExhibitorsLogoList({exhibition_id:'', platform_type:0, ad_id:15, ad_type:1}).then(
            (res) => {
              console.log("000    " , res);
              if(res.data[0].file_path != "") {
                this.video_path = res.data[0].file_path;
                this.video_img = res.data[0].video_img;
              }
            }
        );

        //获取首页轮播图下面的视频数据
        getExhibitorsLogoList({exhibition_id:'', platform_type:0, ad_id:16, ad_type:1}).then(
            (res) => {
              console.log("000上面：    " , res);
              if(res.data[0].file_path != "") {
                this.video_pathTop = res.data[0].file_path;
                // this.video_img = res.data[0].video_img;
              }
            }
        );

        // console.log('1111111111111pppppppppppppppp33333333333');
        // console.log(this.file_path);
        // data[0]['file_path']=this.file_path;
        // console.log('1111111111111pppppppppppppppp');
        // console.log(data);
        // this.exhibitionList = data;

        //  if (res.datacount > this.exhibitionList.length) {
        //   this.showContentMore = true;
        // }else{
        //   this.showContentMore = false;
        // }

        // this.total = parseInt(res.datacount);

        // this.getContentWrapHeight();
        //回到顶部

    });

      /*
        const param = {
          // type: this.exhibitionState,
          // keyword: this.exhibitionName,
          // ckeyword: this.companyName,
          currentPage: this.currentPage,
          lan: this.lan,
        };
      */
      //获取展会信息
      /*getExhibitionInfo("/exhibition", param).then((res) => {
        if (res.data.count > 3) {
          this.showContentMore = true;
        }
        let data = res.data.data;
        this.exhibitionList = data.slice(0, 4);
        this.moreExhibitionList = data.slice(4, data.length);
        this.total = res.data.count;
        this.getContentWrapHeight();
      });*/

      // if(res){
      //     if (res.type == 0) {
      //         util.ErrMessage(this,res);
      //     }

      //     // if(res.datacount > 3){
      //     //   this.showContentMore = true;
      //     // }
      //     // this.exhibitionList = res.data.slice(0,4);
      //     // this.moreExhibitionList = res.data.slice(4,res.data.length);
      //     // this.total = res.datacount;
      //     // this.getContentWrapHeight();
      // }
    },
    seeSearchContentMore() {
      /*let max=this.moreExhibitionList.length>5?5:this.moreExhibitionList.length

      this.exhibitionList = this.exhibitionList.concat(this.moreExhibitionList.slice(0, max));
      this.moreExhibitionList=this.moreExhibitionList.slice(5, this.moreExhibitionList.length)
      if (this.moreExhibitionList<=0) {
        this.showContentMore = false;
      }
      this.getContentWrapHeight();*/
      window.location.href  = "moreJonFair.html";
      return;

      this.currentPage++;
      const param = {
        type: this.exhibitionState,
        keyword: this.exhibitionName,
        ckeyword: this.companyName,
        currentPage: this.currentPage,
        numberPage: 5,
        lan: this.lan,
      };
      selectList(param).then((res) => {


        let data = res.data;
        this.exhibitionList = this.exhibitionList.concat(data);

        if (res.datacount > this.exhibitionList.length) {
          this.showContentMore = true;
        }else{
          this.showContentMore = false;
        }
        this.getContentWrapHeight();
      });


      // const prop = {
      //   type: this.exhibitionState,
      //   keyword: this.exhibitionName,
      //   ckeyword: this.companyName,
      //   currentPage: 2,
      //   numberPage: '999',
      // };
      // selectList(prop).then(res => {
      //   if (res.type != '1') {
      //     if (this.lan == "ch") {
      //       return this.$message.error({message: res.text, offset: 240})
      //     }
      //     return this.$message.error({message: res.text_en, offset: 240})
      //   }
      //   res.data.forEach(item => {
      //     if (this.lan == "en") {
      //       item.exh_begtime = `${item.exh_begtime_en}`;
      //       item.exh_endtime = `${item.exh_endtime_en}`;
      //     }
      //   });
      //   this.showContentMore = false;
      //   this.exhibitionList = [...this.exhibitionList,...res.data];
      //   // this.total = res.datacount;
      //   this.getContentWrapHeight();
      // }).catch(err => {
      //   console.log(err);
      // });
    },

    // 邀请码分享
    showImg(e) {
      let data = {
        exhibition_id: e.exhibition_id,
        broadcast_id: e.broadcast_id,
        currentTab: "1",
      };
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axios
        .post(
          reqest.adminapi+"MakeQr/getExhibitionRr",
          // axios.post('http://exhixcx.shippingchina.com/adminapi.php/Home/MakeQr/getExhibitionRr',
          data,
          {}
        )
        .then((res) => {
          loading.close();
          if (res.data.type == "1") {
            // this.imgSrc = res.data.data.qr_base64;
            this.imgSrcList = res.data.data.img;
            this.showImgDialogFormVisible = true;
          } else {
            if (this.lan == "ch") {
              const height = document.body.clientHeight / 2;
              return this.$message.error({ message: res.text, offset: height });
            }
            return this.$message.error({ message: res.text_en, offset: 120 });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    changeImgSrc(index) {
      this.imgSrcIndex = index;
    },

    // 跨域文件下载
    downloadIamge(url, fileName) {
      url = url.replace(/\\/g, "/");
      const xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
      //xhr.setRequestHeader('Authorization', 'Basic a2VybWl0Omtlcm1pdA==');
      xhr.onload = () => {
        if (xhr.status == 200) {
          let data = xhr.response;
          let name = fileName;

          var urlObject = window.URL || window.webkitURL || window;
          var export_blob = new Blob([data]);
          var save_link = document.createElementNS(
            "http://www.w3.org/1999/xhtml",
            "a"
          );
          save_link.href = urlObject.createObjectURL(export_blob);
          save_link.download = name;
          save_link.click();
        }
      };

      xhr.send();
    },
    imgDown() {
      this.downloadIamge(this.imgSrcList[this.imgSrcIndex], 'pic.jpg')
      // location.href =
      //   "https://exhxcx.shippingchina.com/api.php/Home/Pub/downloadfile?file_path=" +
      //   this.imgSrcList[this.imgSrcIndex];
    },

    // imgDown(){
    //     var alink = document.createElement("a");
    //     alink.href = this.imgSrcList[this.imgSrcIndex];
    //     alink.download = "pic.jpg"; //图片名
    //     alink.click();
    //     this.showImgDialogFormVisible = false;
    // },

    cancelImg() {
      this.showImgDialogFormVisible = false;
    },

    // cancelImg(){
    //   this.showImgDialogFormVisible = false;
    // },
    handleToken() {
      this.title = this.language.helpfulHints;
      this.promptContent = this.language.notLogin;
      this.type = 1;
      this.showHint = true;
    },
    handleExhList(val) {
      this.page = val.page;

      if (this.companyName != "" && this.companyName != null) {
        this.numberPage = 10;
        this.searching = true;
        // this.getExhList();
        this.getCompanySelectList();
      } else {
        this.getExhList();
      }
    },

    getExhList() {
      this.liveList = [];
      this.loading = true;
      let props = {
        // exhibition_id: this.exhibitionId,
        broadcast_type: 1,
        // broadcast_class_id: this.liveClassNumber,
        keyword: this.companyName,
        ckeyword: this.exhibitionName,
        currentPage: this.page,
        numberPage: this.numberPage,
        orderby: "desc",
        exhibitionState: this.exhibitionState,
        lg: this.lan == "ch" ? "zh" : "en",
        k_from: "index",
      };

      if (this.token != null && this.token != undefined) {
        props.user_user = this.userInfo.user;
        props.token = this.token;
      }
      //直播间 论坛列表列表
      getBroadcastList(props).then((res) => {
        if (res.type != 1) {
          return;
        }
        for (let i = 0; i < res.data.length; i++) {
          //if (this.lan == "en" && res.data[i].broadcast_type == 2) {
          if (this.lan == "en") {
            res.data[i].broadcast_name = res.data[i].broadcast_name_en;
            res.data[i].broadcast_introduce =
              res.data[i].broadcast_introduce_en;
            res.data[i].location = res.data[i].location_en;
            res.data[i].user_post = res.data[i].user_post_en;
            res.data[i].truename = res.data[i].truename_en;
            res.data[i].company = res.data[i].company_en;
            res.data[i].broadcast_class_name =
              res.data[i].broadcast_class_name_en;
          }
          if (
            res.data[i].broadcast_logo &&
            res.data[i].broadcast_logo != null
          ) {
            res.data[i].new_broadcast_logo = res.data[i].broadcast_logo.replace(
              "https://exhxcx.shippingchina.com/Public/uploads",
              "https://www.wiffa-exh.com/Public/uploads"
            );
          } else {
            res.data[i].new_broadcast_logo = "";
          }
        }
        // console.log(res.data);
        this.liveList = res.data;
        this.total = parseInt(res.datacount);
        this.loading = false;
      });
    },
    newHandleInfo(data) {
      let _this = this;
      if (this.token == null || this.token == undefined) {
        this.loginData = { exhibitionId: this.exhibitionId };
        this.handleToken();
        return;
      }
      if (!isInternet() && data.state == this.stateEnum.JOIN_DISCUSS) {
        return (this.downloadShow = true);
      }
      this.broadcastId = data.id;

      //获取是否可以无票进入直播间
      liverRoomBuy({}).then((res) => {
        // console.log(res);
        // return;
        if (res == 0) {
          const props = {
            token: this.token,
            broadcast_id: data.id,
          };
          //进入直播间
          this.$store
            .dispatch("getLiveInfo", props)
            .then((res) => {
              const height = document.body.clientHeight / 2;
              if (res.type != "1") {
                if (res.type == "e1") {
                  this.$message.error({
                    message: this.lan == "ch" ? res.text : res.text_en,
                    offset: height,
                  });
                  setTimeout(function() {
                    return window.open(
                      ticketsRegisterUrl(4, _this.exhibitionId)
                    );
                  }, 2000);
                }
                if (isEmpty(res.data)) {
                  if (this.lan == "ch") {
                    return this.$message.error({
                      message: res.text,
                      offset: height,
                    });
                  } else {
                    this.$message.error({ message: res.text_en, offset: height});
                  }
                  return;
                }
                const data = res.data[0];
                if (data.type != 1) {
                  if (this.lan == "ch") {
                    return this.$message.error({
                      message: res.text,
                      offset: height,
                    });
                  } else {
                    this.$message.error({ message: res.text_en, offset: height});
                  }
                  return;
                }
                const waitData = {
                  token: this.token,
                  roomid: data.roomid,
                };
                //需要排队
                if (res.data[0].type == 1) {
                  this.waitData = waitData;
                  this.visibleLine = true;
                }
                return;
              }
              const data = res.data[0];
              let name = Cookie.get("lang") == 'ch' ? (this.userInfo.true_name || this.userInfo.true_name_en) : (this.userInfo.true_name_en || this.userInfo.true_name);
              return window.location.href = windowsGoTo() + roomUrl(data, name);
              // return window.open(
              //   windowsGoTo() + roomUrl(data, this.userInfo.true_name)
              // );
              const goData = {
                token: this.token,
                roomid: data.roomid,
              };
            })
            .catch(() => {});
        } else {
          const props = {
            token: this.token,
            broadcast_id: data.id,
          };
          //进入直播间
          this.$store
            .dispatch("getNewLiveUrl", props)
            .then((res) => {
              const height = document.body.clientHeight / 2;
              if (res.type != "1") {
                if (isEmpty(res.data)) {
                  if (this.lan == "ch") {
                    return this.$message.error({
                      message: res.text,
                      offset: height,
                    });
                  } else {
                    this.$message.error({ message: res.text_en, offset: height });
                  }
                  return;
                }
                const data = res.data[0];
                if (data.type != 1) {
                  if (this.lan == "ch") {
                    return this.$message.error({
                      message: res.text,
                      offset: height,
                    });
                  } else {
                    this.$message.error({ message: res.text_en, offset: height });
                  }
                  return;
                }
                const waitData = {
                  token: this.token,
                  roomid: data.roomid,
                };
                //需要排队
                if (res.data[0].type == 1) {
                  this.waitData = waitData;
                  this.visibleLine = true;
                }
                return;
              }
              const data = res.data[0];
              let name = Cookie.get("lang") == 'ch' ? (this.userInfo.true_name || this.userInfo.true_name_en) : (this.userInfo.true_name_en || this.userInfo.true_name);
              return window.location.href =  windowsGoTo() + roomUrl(data, name);
              // return window.open(
              //   windowsGoTo() + roomUrl(data, this.userInfo.true_name)
              // );
              const goData = {
                token: this.token,
                roomid: data.roomid,
              };
            })
            .catch(() => {});
        }
      });
    },
    handleLive(data) {
      let _this = this;
      console.log(data);
      if (this.token == null || this.token == undefined) {
        this.loginData = { exhibitionId: this.exhibitionId };
        this.handleToken();
        return;
      }
      if (!isInternet() && data.state == this.stateEnum.JOIN_DISCUSS) {
        return (this.downloadShow = true);
      }
      this.broadcastId = data.id;
      const props = {
        token: this.token,
        broadcast_id: data.id,
      };
      if (data.state == this.stateEnum.SEE_CONTACT) {
        selectContact(props)
          .then((res) => {
            if (res.type != "1") {
              if (this.lan == "ch") {
                const height = document.body.clientHeight / 2;
                return this.$message.error({ message: res.text, offset: height });
              }
              return this.$message.error({ message: res.text_en, offset: 120 });
            }
            this.$alert(
              res.data[0].broadcast_contact,
              this.language.hintContact,
              {
                confirmButtonText: this.language.confirm,
                callback: (action) => {},
              }
            );
          })
          .catch(() => {});
        return;
      }
      //预约
      if (data.state == this.stateEnum.SUBSCRIBE) {
        subscribe(props).then((res) => {
          const height = document.body.clientHeight / 2;
          if (res.type != "1") {
            if (res.type == "e1") {
              this.$message.error({
                message: this.lan == "ch" ? res.text : res.text_en,
                offset: height,
              });
              setTimeout(function() {
                // return (window.location.href = tickUrl(
                //     1,
                //     _this.exhibitionId
                // ));
                return (window.location.href = ticketsRegisterUrl(
                  4,
                  _this.exhibitionId
                ));
              }, 2000);
            }
            if (this.lan == "ch") {
              return this.$message.error({ message: res.text, offset: height });
            }
            return this.$message.error({ message: res.text_en, offset: height });
          }
          if (this.lan == "ch") {
            this.$message.success({ message: res.text, offset: height });
          } else {
            this.$message.success({ message: res.text_en, offset: height });
          }
          var newObjack = this.liveList.filter((item) => {
            return item.broadcast_id == res.datacount;
          });

          this.$refs["ontoone"][data.k].aloneData.subscribe_type = 1;
          // this.getExhList();
        });
      }
      //取消预约
      if (data.state == this.stateEnum.CANCELSUB) {
        subscribeCancel(props).then((res) => {
          const height = document.body.clientHeight / 2;
          if (res.type != "1") {
            if (this.lan == "ch") {
              return this.$message.error({ message: res.text, offset: height});
            }
            return this.$message.error({ message: res.text_en, offset: height });
          }
          if (this.lan == "ch") {
            this.$message.success({ message: res.text, offset: height });
          } else {
            this.$message.success({ message: res.text_en, offset: height });
          }
          var newObjack = this.liveList.filter((item) => {
            return item.broadcast_id == res.datacount;
          });
          this.$refs["ontoone"][data.k].aloneData.subscribe_type = 0;
          // this.getExhList();
        });
      }
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    playv(e) {
      var that = this;
      that.b = false;
      that.play = true;
      setTimeout(function() {
        let el = document.querySelector("#video0");
        //if (el == "object") {
          let msrc = el.getAttribute("msrc");
          if (that._isMobile() && msrc != "") {
            el.src = el.getAttribute("msrc");
          } else {
            el.src = el.getAttribute("tsrc");
          }
          var ec = el.play();
          if (ec != undefined) {
            ec.then(function() {
              el.play();
              el.volume = 0.5;
            }).catch(function() {});
          }
        //}
      }, 2000);
    },

    //  getNoticeList() {
    //       noticeList({
    //         position:'0',
    //       }).then(res => {
    //         this.datacount = res.datacount * 1;
    //         // console.log(this.datacount,'1111111');
    //         if(res.data != null) {
    //           res.data.forEach(item => {
    //             if (this.lan == "en") {
    //               item.exh_name = `${item.exh_name_en}`;
    //             }
    //           });
    //           this.dataList = res.data;
    //         }
    //     });
    //  },

    initBanner() {
      // var that = this;
      let param = {
        lan: Cookie.get("lang"),
        mobile: this._isMobile(),
      };

      //1、单视频 2、视频轮播 3、单图片 4、图片轮播
      /*getBanner("/banner", param).then((res) => {
        console.log("==========banner================", res);
        this.carouselType = res.data.type;
        this.carouselImage = res.data.data;
        if (this.carouselType == 3 && this.carouselImage.length == 1) {
          this.swiperOptions.loop = false;
          this.swiperOptions.autoplay = false;
        } else {
          this.optiontime.loop_time = res.data.loop_time;
          // this.$nextTick(() => {
          //   this.optiontime.loop_time = parseInt(this.optiontime.loop_time);
          // });
        }
        if (!this._isMobile() && this.carouselType == 2) {
          this.playv();
        }
      });*/

      // getBanner(param).then(res => {
      //     that.carouselType = res.type;
      //     that.carouselImage = res.data;
      //     if(that.carouselType == 3 && that.carouselImage.length == 1){
      //       this.swiperOptions.loop = false;
      //       this.swiperOptions.autoplay = false;
      //     }else {
      //       that.optiontime = res.datacount;
      //       that.$nextTick(() => {
      //         that.optiontime.loop_time = parseInt(that.optiontime.loop_time);
      //       })
      //     }
      //     if(!that._isMobile() && that.carouselType == 2){
      //         that.playv();
      //     }
      // });
    },


    getPagination(val) {
      this.currentPage = val.page;
      this.loadData();
    },
    search() {
      if (this.companyName != "" && this.companyName != null) {
        this.page = 1;
        this.searching = true;
        // this.getExhList();
        this.getCompanySelectList();
      } else {
        this.page = 1;
          this.loadData();
          this.currentPage = 1;
          this.searching = false;
          this.getContentWrapHeight();
      }
    },
    handledTypeJoin(type, exhibition_id) {

      if (type != this.ExhibitionHandleEnum.ENTER_ROOM) {
        if (this.token === null || this.token === undefined) {
          this.title = this.language.helpfulHints;
          this.promptContent = this.language.notLogin;
          this.type = 1;
          this.loginData = { type: type, exhibitionId: exhibition_id };
          this.showHint = true;
          return;
        }

        return (window.location.href = tickUrl(type, exhibition_id));
      }
      if (exhibition_id == "29") {
        return (window.location.href =
          "internationalFair.html" + "?exhibition_id=" + exhibition_id);
      } else {
        return (window.location.href =
          "forum.html" + "?exhibition_id=" + exhibition_id);
      }
    },

    handleRegister(type, exhibition_id, zhifu) {

      //我要支付
      if (this.token === null || this.token === undefined) {
        this.title = this.language.helpfulHints;
        this.promptContent = this.language.notLogin;
        this.type = 4;
        this.loginData = { type: type, exhibitionId: exhibition_id };
        this.showHint = true;
        // window.location.href = "login.html?type=4&exhibitionId=" + exhibition_id;
      } else {
        //是否是子账号
        if(this.userInfo.superioruser_id != 0){
          const height = document.body.clientHeight / 2;
          if(zhifu == 1) {
            this.$message.error({message:"子账号不能进行报名", offset:height})
          }else if(zhifu == 2) {
            this.$message.error({message:"子账号不能进行支付", offset:height})
          }
          return;
        }
        getExhticketUserCount({exhibition_id: exhibition_id, user_id: this.userInfo.user_id}).then(res => {
          let params = "exhibitionId=" + exhibition_id;
          let encodeData = window.btoa(window.encodeURIComponent(params));
          let data = res.data;
          let exhibitionNum = data.exhibitionNum;
          let exhibitionViewingNum = data.exhibitionViewingNum;
          if(res.type == 1 && (exhibitionNum + exhibitionViewingNum) > 0){
            let userName = this.lan == 'ch'?(this.userInfo.true_name||this.userInfo.true_name_en):(this.userInfo.true_name_en)||this.userInfo.true_name;

            let message = language().ticketsTips1.replace('{0}', userName);
            let msg = '';
            if(exhibitionViewingNum > 0){
              msg += language().ticketsTips2.replace('{0}', exhibitionViewingNum);
            }
            if(exhibitionNum > 0){
              if(msg == ''){
                msg += language().ticketsTips3.replace('{0}', exhibitionNum);
              }else{
                msg += (this.lan == 'ch'?'和':' and ') + language().ticketsTips3.replace('{0}', exhibitionNum);
              }
            }
            message = message.replace('{1}', msg)
            this.retipMess = message;
            this.payExh = true;
            this.encodeData = encodeData;
            // MessageBox({
            //   title: language().hint,
            //   message: message,
            //   confirmButtonText: language().confirm,
            //   cancelButtonText: language().cancel,
            //   dangerouslyUseHTMLString:true,
            //   showCancelButton: true,
            //   type: 'warning'
            // }).then(() => {
            //   //确认
            //   localStorage.setItem("buyBackUrl", location.href);
              // window.location.href = "ticketsRegister.html?" + encodeData;
            // }).catch(() => {
            //   //取消
            // });
          }else{
            localStorage.setItem("buyBackUrl", location.href);
            window.location.href = "ticketsRegister.html?" + encodeData;
          }

        });

      }
    },
    payOk() {
      this.payExh = false;
      localStorage.setItem("buyBackUrl", location.href);
      window.location.href = "ticketsRegister.html?" + this.encodeData;
    },
    payNo() {
      this.payExh = false;
    },
    getConfirm(type, loginData) {

      //用户没登录
      if (type == 1) {
        window.location.href = "login.html?type=" + loginData.type + "&exhibitionId=" + loginData.exhibitionId;
      }
      if(type == 4){
        window.location.href = "login.html?type=4&exhibitionId=" + loginData.exhibitionId;
      }
      if(type == 8888){
        window.location.href = "login.html?type=8888&exhibitionId=" + loginData.exhibitionId;
      }
      //用户没购票
      this.showHint = false;
    },
    getWebStock() {
      var that = this;
      init({ token: this.token }, onmessage);
      function onmessage(data) {
        that.clientId = data.data.client_id;

        //console.log("22222222222222222222222");
        if (data.data.type == "2") {
          that.warnConten = data.data;
          that.warnVisible = true;
          // console.log('333333333333333333333333')
        }
      }
      // console.log('11111111111111111111')
    },
    isIE() {
      //ie?
      var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
      var isIE =
        userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
      var isIE11 =
        userAgent.indexOf("Trident") > -1 && userAgent.indexOf("rv:11.0") > -1;

      var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器

      if (isIE || isEdge || isIE11) {
        return true;
      } else {
        return false;
      }
    },
    handleCarousel(index) {
      if (this.carouselType == 2) {
        this.carouselImage.map((_, _index) => {
          if (index == 1) {
            document.getElementById(`video0`).pause();
            // document.getElementById(`video0`).setAttribute("muted");
          }
          if (_index == index) {
            setTimeout(function() {
              let el = document.getElementById(`video` + _index);

              el.src = el.getAttribute("tsrc");
              el.play();
            }, 2000);

            // document.getElementById(`video${_index}`).removeAttribute("muted");
          } else {
            document.getElementById(`video${_index}`).pause();
            // document.getElementById(`video${_index}`).setAttribute("muted");
          }
        });
      }
    },

    async getCompanySelectList() {
      this.liveList = [];
      this.loading = true;
      let props = {
        keyword: this.companyName,
        currentPage: this.page,
        numberPage: this.numberPage,
        lan: this.lan,
        orderByFlag: "status",
        broadcast_class_id: this.liveClassNumber,
        exhibitionState: this.exhibitionState,
      };
      if (this.token != null && this.token != undefined) {
        props.user_user = this.userInfo.user;
        props.token = this.token;
      }
      //直播间
      // const res = await CompanySelectList(props);

      //const res = await getCompanys("/Companys", props);
      //直播间显示 0隐藏1显示
      props.broadcast_show=1;
      const res = await getCompanysList(props);
      if (res) {

        this.broadcastNum = res.datacount * 1;
       // this.topLiveList = res.text_en;
        this.liveList = [...res.data];
        // for(var i in res.data.data){

        // }
        this.total = res.datacount * 1;
        this.loading = false;
        this.getContentWrapHeight();
      }
    },

    broadCastTotalHandleExhList(val) {
      this.broadCastTotalPage = val.page;
      let params = {
        user_id: this.dialogUserId,
        finally_in_exhibtion: this.dialogFinallyInExhibtion,
      };
      this.showParticipants(params);
    },

    async showParticipants(item, index) {
      let e = item[0];
       console.log('---------------',e);
       window.open('forum.html?exhibition_id='+e.ExhibitionId+'&room_id='+e.user_id);

      return;
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let data = {
        user_id: e.user_id,
        login_user_id: this.userInfo.user_id,
        exhibition_id: e.ExhibitionId
      };
      const res = await getCompanysDetails(data);
      // 获取直播间
      if (res) {
        loading.close();
        if (res.type == 0) {
          util.ErrMessage(this, res);
        }
        this.dialogUserId = e.user_id;
        this.dialogFinallyInExhibtion = e.finally_in_exhibtion;
        this.broadCastTotal = res.datacount * 1;
        this.broadCastList = res.data;
        this.showParticipantsDialogFormVisible = true;
      }
    },

    // 分享链接
    showPcUrl(e) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let data = {
        exhibition_id: e.exhibition_id,
        broadcast_id: e.broadcast_id,
      };
      //获取直播间分类
      pcShareLink(data).then((res) => {
        loading.close();
        const height = document.body.clientHeight / 2;
        if (res.type != "1") {
          if (this.lan == "ch") {
            return this.$message.error({ message: res.text, offset: height });
          }
          return this.$message.error({ message: res.text_en, offset: height});
        }
        this.pcUrl = res.data;
        this.showPcUrlDialogFormVisible = true;
      });
    },
    copyPcUrl() {
      let url = this.pcUrl;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      console.log(oInput.value);
      document.execCommand("Copy"); // 执行浏览器复制命令
      const height = document.body.clientHeight / 2;
      this.$message({
        message: "复制成功",
        type: "success",
        offset:height
      });
      oInput.remove();
    },

    getContentWrapHeight() {
      this.$nextTick(() => {
        let contentWrapHeight = this.$refs.contentWrap.offsetHeight;
        let bgListLength = Math.ceil(contentWrapHeight / 385)+1;
        console.log("======bgListLength=======", bgListLength);

        this.bgList.length = bgListLength;
        console.log("====1111111111====", this.bgList);
        this.$forceUpdate();
      });
    },
    getNoticeAll(){
      let params = {
        type: "0"
      };
      getNoticeAll(params).then((resp) => {
        let res = resp;
        if (resp.type == 1) {
          let obj = res.data || [];
          let chIndex=1;
          let enIndex=1;

          let chNotice=""
          let enNotice=""
          for(let row of obj){
            if (row.use_edition==2) {
              chNotice+=chIndex+++"."+row.send_text+"&nbsp;&nbsp;&nbsp;&nbsp;"
              enNotice+=enIndex+++"."+row.send_text_en+"&nbsp;&nbsp;&nbsp;&nbsp;"
            }else if (row.use_edition==1) {
             enNotice+=enIndex+++"."+row.send_text_en+"&nbsp;&nbsp;&nbsp;&nbsp;"
            }else  if(row.use_edition==0){
              chNotice+=chIndex+++"."+row.send_text+"&nbsp;&nbsp;&nbsp;&nbsp;"
            }
          }
          if (this.lan == "ch") {
            this.allNotice=chNotice
          }else{
            this.allNotice=enNotice
          }
        }
      });
    },
  },

  updated() {
    // if(this.isIE() || this._isMobile()) {
    //     var v2 = $("#video0").width();
    //     var v1 = $(".videoBox").width();
    //     var v3 = (v2 - v1) / 2;
    //     $("video").css("margin-left", -v3);
    //     if(this._isMobile()){
    //       $("video").attr("controls","controls");
    //     }
    // }else{
    //     $("video").attr("controls","controls");
    //     $("video").width("100%");
    // }
  },

  mounted() {
    this.getTopImg();
    this.loadData();
    let lan = Cookie.get("lang");
    if (lan == "ch") {
    } else {
      this.duilianImg = require("../../assets/duilian_en.jpg");
      // this.duilianUrl = 'https://www.wiffa-exh.com/videolist.html#/';
      this.duilianUrl = "http://www.wiffa.net/meeting2021/pren/index.html";
      // this.duilianUrl = "../../videolist.html#/";
      this.exhibitionImg = require("../../assets/duilian_en.jpg");
      this.alertadImg = require("../../assets/alertad_en.jpg");
      this.alertadUrl =
        "https://www.wiffa-exh.com/forum.html?exhibition_id=19#/";
      // this.alertadUrl = 'https://www.wiffa-exh.com/videolist.html#/';
      // this.alertadUrl = '../../videolist.html#/'

      //this.adSideLinkImg = require('../../assets/icon_gz_bg_new.jpg');
      // this.adSideLinkUrl = "https://www.wiffa-exh.com/adIntroduce.html";
    }

    //0中文, 1英文
    let platform_type = 0;
    if (lan != "ch"){
      platform_type = 1;
    }
    getBannerList({platform_type: platform_type}).then((res) => {
      console.log(res)
        if(res.data){
          let bannerList = res.data;
          if(bannerList.length >0){
            //0图片,1视频
            let type = bannerList[0].type;
            let loop_time = bannerList[0].loop_time;
            // this.swiperOptions.speed = loop_time;
            this.optiontime.loop_time = parseInt(loop_time);
            // debugger;
            if(type == 1) {
              if(bannerList.length == 1){
                this.carouselType = 1;
              }else{
                this.carouselType = 2;
              }
            }else{
              this.carouselType = 4;
            }
            // this.carouselType = type == 1 ? 2 : 4;
            this.carouselImage = bannerList;
            // console.log("---222333: " + this.carouselType);

          }
          /*this.$nextTick(function () {
            this.$refs.mySwiper.initSwiper();
         })*/
        }
    });

    this.getNoticeAll();

  },
  created() {
    this.initBanner();
    // this.getNoticeList();
  },
  computed: {
    ...mapGetters(["token", "userInfo"]),
  },
  watch: {
    // exhibitionState: {
    //   handler() {
    //     this.search();
    //   },
    //   immediate: true
    // },
    b(d, c) {
      if (d == false) {
      }
    },
  },
};
</script>

<style scoped>
.m_top {
  background: transparent !important;
}
.exhibition-content-wrap {
  position: relative;
  margin-top: 15px;
}
.bg-wrap {
  width: 100%;
  min-width: 1200px;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: 0 auto;
  z-index: 0;
}
.bg-wrap div:nth-child(2n-1) {
  width: 100%;
  height: 400px;
  /*background: url("../../assets/index-bg-1.jpg");*/
  background: #f1f6fe;
  /*background-color: #f2f7ff;*/
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.bg-wrap div:nth-child(2n) {
  width: 100%;
  height: 400px;
  /*background: url("../../assets/index-bg-2.jpg");*/
  background: #f1f6fe;
  /*background: #036ffc;*/
  /*background-color: #f2f7ff;*/
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.bg-wrap div:last-child {
  /*background: #0c6dce !important;*/
  background: transparent;
  /* background-size: 100% 100%;
  background-repeat: no-repeat; */
}
.content-wrap {
  margin-top: -14px;
  /* position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 auto;
  z-index: 1; */
  /* position: relative;
  top: 0; */
}
.index-banner-top-en {
  width: 100%;
  min-width: 1200px;
  /*height: 25vw;*/
  min-height: 350px;
  /* object-fit: cover; */
  margin-top: -81px;
  /*background: url("../../assets/bg111.jpg");*/
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  text-align: left;
  padding: 10px 0;
}
.index-banner-top {
  width: 100%;
  /*height: 480px;*/
  height: 580px;
  /* object-fit: cover; */
  margin-top: -81px;
  background: url("../../assets/img/34.jpg");
  background-size: cover !important;
  background-position: center !important;
  /*background-size: 100% 100%;*/
  background-repeat: no-repeat !important;
  position: relative;
  text-align: left;
  padding: 10px 0;
}
.index-banner-wrap {
  width: 100%;
  padding-top: 14%;
}
.index-banner-position {
  width: 800px;
  /* padding-left: 140px;
  margin: 0 auto; */
  margin-left: 22.3%;
}
.index-banner-position-top {
  font-size: 28px;
  color: #fff;
}
.index-banner-position-top-left {
  padding-right: 10px;
  border-right: 0.5px solid #fff;
}
.index-banner-position-top-right {
  padding-left: 10px;
  border-left: 0.5px solid #fff;
}
.index-banner-position-content {
  font-size: 16px;
  color: #fff;
  padding: 20px 0;
}
/* .index-banner-position-btn{

} */
.index-banner-position-btn div {
  display: inline-block;
  padding: 5px 20px;
  border-radius: 30px;
  background: url("../../assets/bg-btn.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  cursor: pointer;
}
.index-banner-position-btn div img {
  width: 24px;
  height: 24px;
  vertical-align: middle;
  margin-right: 10px;
  margin-top: -5px;
}
.index-banner-position-btn div span {
  font-size: 20px;
  color: #fff;
  padding-top: 2px;
}

.dislogCon-Participants >>> .el-dialog__body {
  margin-top: 50px;
  padding: 30px 50px !important;
}

.dialog-top {
  text-align: left;
  padding: 20px 25px;
  background-color: #ececec;
}
.broadCastList-company {
  font-size: 14px;
  color: #000;
  font-weight: bold;
  text-align: left;
}

.index_bottom {
  width: 100%;
  min-width: 1200px;
  height: 600px;
  min-height: 300px;
  /*display: flex;*/
  /*background: url("../../assets/index_bottom_bg.jpg");*/
  background-size: 100% 100%;
  background: #f1f6fe;
  background-repeat: no-repeat;
  position: relative;
  /*margin-top: 45px;*/
  z-index: 1;
}
.bottom-left, .bottom-right {
  /*width: 592px;*/
  /*!*height: 135px;*!*/
  /*background-color: #ffffff;*/
  /*border-radius: 10px;*/
}
.firmMes {
  height: 190px;
  margin: 15px 0;
  width: 592px;
  /*height: 135px;*/
  background-color: #ffffff;
  border-radius: 10px;
}
.mesright {
  float: right;
}
.mesTitle {
  width: 420px;
  height: 20px;
  font-family: SourceHanSansCN-Bold;
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  line-height: 18px;
  letter-spacing: 0px;
  color: #333333;
  text-align: left;
  padding-top: 24px;
}
.mesContent {
  width: 405px;
  height: 40px;
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 0px;
  color: #333333;
  text-indent: 2em;
  margin-top: 5px;
}
/*.index_bottom div {*/
/*  flex: 1;*/
/*  margin: 0 auto;*/
/*  text-align: center;*/
/*}*/
.index_bottom div img {
  width: 311px;
  /*height: 70px;*/
  text-align: center;
  margin: 20px auto 20px;
  /* display: inline-flex;
  align-items: center;
  justify-items: center; */
}
.index_bottom div p {
  font-size: 18px;
  color: #fff;
  display: block !important;
  margin: 0 0 10px;
}
.banner2 {
  width: 100%;
  height: 20vw;
  /*max-width: 1920px;*/
  /*height: 400px;*/
  background: url("../../assets/img/30.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  /*margin: 0 auto;*/
  z-index: 1;
}
.banner3 {
  width: 1200px;
  text-align: center;
  margin: 0 auto;
  /*height: 700px;*/
  /*background: url("../../assets/img/20.png");*/
  /*background-size: 100% 100%;*/
  /*background-repeat: no-repeat;*/
  /*position: relative;*/
}
.banner4 {
  width: 100%;
  height: 20vw;
  /*max-width: 1920px;*/
  /*height: 400px;*/
  background: url("../../assets/img/31.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  z-index: 1;
  /*margin:  0 auto;*/
}
.index-diqiu {
  width: 100%;
  /*min-width: 1200px;*/
  height: 690px;
  /*height: 35vw;*/
  /*max-width: 1920px;*/
  /*height: 736px;*/
  /*display: flex;*/
  background: url("../../assets/img/37.png");
  /*background-size: 100% 100%;*/
  /*background-repeat: no-repeat;*/
  background-size: cover !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
  position: relative;
  /* margin-top: 45px; */
  /*margin: 0 auto;*/
  z-index: 1;
}
.index-diqiu .word {
  width: 500px;
  height: 58px;
  font-family: SourceHanSansCN-Bold;
  font-size: 60px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 48px;
  letter-spacing: 0px;
  color: #ffffff;
}
.index-diqiu .word1 {
  width: 880px;
  height: 45px;
  font-family: SourceHanSansCN-Regular;
  font-size: 48px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 48px;
  letter-spacing: 38px;
  color: #ffffff;
  position: relative;
  left: -170px;
  top: 40px;
}
.index-diqiu-en {
  width: 100%;
  min-width: 1200px;
  height: 30vw;
  min-height: 360px;
  display: flex;
  background: url("../../assets/index_dq.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  /* margin-top: 45px; */
  z-index: 1;
}
.index-diqiu-title {
  position: absolute;
  top: 12%;
  left: 45.8%;
  font-size: 260%;
  color: #fff;
}

/*右侧广告位*/
.show—advisory {
  display: inline-block;
}
.advisory {
}
/*.advisory-img{
		width:110px;
		height:550px;
	}
	*/
.advisory-img {
  width: 80px;
  height: 400px;
}

.advisory-img img {
  width: 80px;
  height: 400px;
}
/*.advisory-left {
		width: 110px;
		height:580px;
		position:fixed;
		bottom:50px;
		left: 30px;
	}*/

.advisory-left {
  width: 80px;
  height: 450px;
  position: absolute;
  /* bottom:50px; */
  top: 590px;
  left: 20px;
  z-index: 2000;
}

.advisory-right {
  width: 110px;
  height: 580px;
  position: absolute;
  top: 500px;
  right: 30px;
}

.ad-service {
  background: #30a2e2;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  font-size: 16px;
}

.code-btn {
  width: 35px;
  height: 35px;
  display: block;
  position: absolute;
  right: 20px;
  bottom: 0;
}

.code-btn img {
  width: 25px;
  height: 25px;
}
/*右侧广告位结束*/

.new-code-btn-right {
  width: 35px;
  height: 35px;
  display: block;
  position: absolute;
  right: 65px;
  bottom: -65px;
  cursor:pointer;
}

.new-code-btn-right img {
  width: 25px;
  height: 25px;
}
.exhibition {
  position: relative;
}
.exhibition img {
  border: 0px;
}
.el-button--primary {
  background: linear-gradient(0deg, rgb(0, 180, 251), rgb(0, 104, 234));
  /* background-color: #0f408a !important;
    border: 1px solid #0f408a !important; */
}
.card_not_data {
  font-size: 20px;
  text-align: center;
  line-height: 232px;
  font-family: "Microsoft YaHei", "微软雅黑", "Helvetica Neue", Helvetica,
    "PingFang SC", "Hiragino Sans GB", Arial, sans-serif;
}
.exhibition {
  width: 100%;
  min-width: 1200px;
  background-color: #f1f6fe;
}

.search {
  width: 1180px;
  height: 41px;
  margin: 13px auto;
  padding: 22px;
  background: #fff;
  position: relative;
}

.search_content {
  width: 1200px;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  margin: 0 auto -20px;
}
.search_content_more {
  width: 1200px;
  margin: 40px auto 0;
  text-align: center;
  z-index: 9;
}
.search_content_more p {
  display: inline-block;
  /*border: 1px solid #fff;*/
  /*padding: 8px 15px;*/
  /*color: #fff;*/
  cursor: pointer;

  width: 193px;
  height: 40px;
  background-color: #f47900;
  border-radius: 28px;
  font-size: 20px;
  color: #FFFFFF;
  padding-top: 10px;
}
.search_content .content {
  z-index: 9;
}

.content {
  /*margin-bottom: 20px;*/
  min-height: 232px;
}
.pagination {
  margin: auto;
  margin-top: 10px;
  margin-bottom: 38px;
  text-align: center;
}
.el-button {
  padding: 8px 20px !important;
}
/*弹出广告--start--*/
.guide-hidden {
  overflow: hidden;
}

.guide-all {
  display: none;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1999;
  background: url("../../assets/bg.png");
}

.all-bg {
  position: relative;
  width: 100%;
  height: 100%;
}
.guide-all .all-layout {
  width: 700px;
  height: 344px;
  margin: 0 auto;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -350px;
  margin-top: -152px;
}

.guide-all a {
  display: block;
  height: 344px;
  width: 700px;

  /*background: url(../images/guide_present_all.png) no-repeat center center;*/
}
.guide-all a img {
  height: 344px;
  width: 700px;
}
.guide-all .guide-all-close {
  width: 39px;
  height: 39px;
  display: block;
  position: absolute;
  right: -40px;
  top: -40px;
  cursor: pointer;
  /*background: url(../images/close_big.png) no-repeat center center;*/
}

.guide-all .guide-all-close img {
  width: 39px;
  height: 39px;
}

.guide-all .guide-all-close:hover {
  /*background: url(../images/close_big_opa6.png) no-repeat center center;*/
}

.guide-bar {
  background: #472273;
  display: none;
}

.guide-bar-layout {
  width: 1000px;
  margin: 0 auto;
  position: relative;
  height: 55px;
}

.guide-bar .guide-bar-close {
  display: block;
  position: absolute;
  right: 0;
  top: 10px;
  width: 35px;
  height: 35px;
  cursor: pointer;
  /*background: url(../images/close_small.png) no-repeat center center;*/
}
.guide-bar .guide-bar-close:hover {
  /*background: url(../images/close_small_opa6.png) no-repeat center center;*/
}

.thumbnail {
  position: fixed;
  left: 30px;
  bottom: 50px;
  width: 110px;
  height: 533px;
  cursor: pointer;
  display: none;
}

@-webkit-keyframes rotate {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}

/*弹出广告--end--*/
.entrance-left-wrap{
  position: fixed;
  width:90px;
  /*left:10%;*/
  top:50%;
  z-index:10;
  transform: translateY(-50%);
  }


.entrance-right-wrap {
  width: 165px;
  position: fixed;
  /*left: 85%;*/
  top: 50%;
  z-index: 10;
  transform: translateY(-50%);
}
.entrance-right-top {
  text-align: center;
  padding: 10px 20px;
  color: #fff;
  background: linear-gradient(0deg, rgb(236, 141, 55), rgb(239, 106, 40));
}
.entrance-right-content {
  background: #fff;
}
.entrance-right-content div {
  border-bottom: 1px solid #000;
  padding: 5px 10px;
  cursor: pointer;
}
.entrance-right-bottom {
  text-align: center;
  padding: 10px 20px;
  color: #fff;
  background: linear-gradient(0deg, rgb(0, 180, 251), rgb(0, 104, 234));
  /*margin-bottom: 20px;*/
}
.entrance-right-qrcode {
  background: #fff;
  color: rgb(0, 104, 234);
  text-align: center;
  padding-bottom: 20px;
}
.entrance-right-qrcode p {
  padding-top: 10px;
  font-size: 16px;
}
</style>
<style>
.swiper-container-free-mode > .swiper-wrapper {
  -webkit-transition-timing-function: linear !important; /*之前是ease-out*/
  -moz-transition-timing-function: linear !important;
  -ms-transition-timing-function: linear !important;
  -o-transition-timing-function: linear !important;
  transition-timing-function: linear !important;
  margin: 0 auto;
}
.swiper-container {
  --swiper-theme-color: #ff6600; /* 设置Swiper风格 */
  --swiper-navigation-color: #00ff33; /* 单独设置按钮颜色 */
  --swiper-navigation-size: 30px; /* 设置按钮大小 */
}
.search .el-form--inline .el-form-item {
  margin-right: 0 !important;
}

.search .el-input__inner {
  border-radius: 0 !important;
  /* border-right: none !important; */
  background-color: #ffffff !important;
}

.search .el-select .el-input__inner:focus {
  border-color: #dcdfe6 !important;
}

.search .el-input__inner:focus {
  border-color: #dcdfe6 !important;
}
.search .el-input-group__append,
.el-input-group__prepend {
  border-radius: 0 !important;
  background-color: #0f408a !important;
  border: #0f408a !important;
}

.videoBox {
  width: 300px;
  height: 150px;
  position: absolute;
  top: 100px;
  left: 40px;
  -webkit-transform: rotateZ(0deg);
}
.videoBox .player {
  position: absolute;
  width: 100%;
  height: 400px;
  top: 0px;
  left: 0px;
  z-index: 3;
}

.videoBox .poster {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
}

.videoBox .playIcon {
  /*width: 23%;*/
  opacity: 0.8;
  position: absolute;
  z-index: 2;
  position: absolute;
  height: 40%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.division-div{
  /*height: 90px;*/
  position: relative;
  width: 1180px;
  margin: 0px auto;
}
.division-div img{
  display: block;
  width: 100%;
}


.adSideLink{
 width:165px;
 margin-top:10px;
}
.adSideLink img{
  width:100%;
  height:auto;
}
.unit_tp {
  width: 1180px;
  height: 510px;
  margin-left: 54px;
  background-repeat: no-repeat !important;
  position: relative;
}

/*.el-backtop {*/
/*    width:auto;*/
/*    height:auto;*/
/*    border-radius: 0px;*/
/*    position: static;*/
/*    font-size: 14px;*/
/*}*/
</style>
